import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import { USER_PERMISSIONS_LIST } from '../../../constants/users';
import styles from './userRow.styles';
import AccordionMenu from '../accordionmenu/AccordionMenu';
import CheckboxControl from '../../inputs/checkboxcontrol/CheckboxControl';
import {
  deleteSiteUserAction,
  editUserAction,
  viewUserLinkAction,
  clearInviteLinkAction,
  resendVerifyAction,
  resendVerifyModalHideAction
} from '../../../reducers/actions';
import AddUserForm from '../../forms/adduserform/AddUserForm';
import Confirm from '../../common/confirm/Confirm';
import Modal from '../../common/modal/Modal';
import { getSelectedSite } from '../../../containers/adminusers/util';

class UserRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showEditUserModal: false,
      showDeleteUserModal: false,
      showInviteLinkModal: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { verificationLink } = nextProps;
    if ((verificationLink === '' || verificationLink !== null) && !this.state.showInviteLinkModal) {
      this.setState({ showInviteLinkModal: true });
    }
    return true;
  }

  handleClick = value => {
    if (value === 'delete') {
      this.setState({
        showDeleteUserModal: true
      });
    }

    if (value === 'edit') {
      this.setState({ showEditUserModal: true });
    }

    if (value === 'viewInvite') {
      const orgId = localStorage.getItem("orgId");
      const { user, sites } = this.props;
      const userdetail = (user && user.data.assetInfo.metadata.props) || {};
      const site = getSelectedSite(sites.list);
      this.props.verifyUserLink(userdetail.email, site.id, orgId);
    }

    if (value === 'resendInvite') {
      const userInfo = this.props.user;
      const { email } = (userInfo && userInfo.data.assetInfo.metadata.props) || {};
      this.props.resendEmail(email);
    }
  };
  handleDeleteUserConfirm = () => {
    this.props.deleteSiteUser(this.props.user.data.id);
    this.handleDeleteClose();
  };

  handleSubmit = values => {
    const site = getSelectedSite(this.props.sites.list).id;
    values.sitePermissions = [site];
    values.id = this.props.user.data.id;
    this.props.editUser(values);
    this.handleEditClose();
  };

  handleEditClose = () => {
    this.setState({
      showEditUserModal: false
    });
  };
  

  handleDeleteClose = () => {
    this.setState({
      showDeleteUserModal: false
    });
  };
  handleLinkVerificationClose = () => {
    this.props.hideVerificationModal();
    this.setState({ showInviteLinkModal: false })
  };

  getOptions=()=>{
    let options = [
      {
        text: I18n.t('edit.edit'),
        value: 'edit'
      },
      {
        text: I18n.t('delete.delete'),
        value: 'delete'
      }
    ];

    if(this.props.isAdmin){
      options=[
        ...options,
        {
         text: I18n.t('resendInvite'),
         value: 'resendInvite'
       },
       {
         text: I18n.t('viewInvite'),
         value: 'viewInvite'
       }
      ]
    }

    return options;
  }

  handleResendInviteClose = () => {
    this.props.hideResendInviteModal();
  };
  render() {
    const options = this.getOptions(); 

    const { user, verificationLink } = this.props;

    const userdetail = (user && user.data.assetInfo.metadata.props) || {};
    const site = getSelectedSite(this.props.sites.list);
    if (site) {
      site.label = site && site.name !== undefined ? site.name : '';
    }
    return (
      <Fragment>
        <div className={css(styles.base)}>
          <div className={css(styles.field)}>
            <span className={css(styles.label, styles.email)}>
              {I18n.t('email.email')}
            </span>
            <span className={css(styles.value)} title={userdetail.email}>
              {userdetail.email}
            </span>
          </div>
          <div className={css(styles.field, styles.adminstyle)}>
            <span className={css(styles.label)}>{I18n.t('admin.Admin')}</span>
            <CheckboxControl isChecked={userdetail.Admin} />
          </div>
          <div className={css(styles.field)}>
            <span className={css(styles.label)}>{I18n.t('admin.status')}</span>
            <CheckboxControl isChecked={userdetail.Status} />
          </div>
          <div className={css(styles.field)}>
            <span className={css(styles.label)}>{I18n.t('add.addTag')}</span>
            <CheckboxControl isChecked={userdetail.AddTags} />
          </div>
          <div className={css(styles.field)}>
            <span className={css(styles.label)}>
              {I18n.t('edit.edit')}/{I18n.t('delete.deleteTag')}
            </span>
            <CheckboxControl isChecked={userdetail.EditDeleteTags} />
          </div>
          <div className={css(styles.field, styles.editwidth)}>
            <span className={css(styles.label, styles.specialwidth)}>
              {I18n.t('add.add')}/{I18n.t('edit.edit')}/
              {I18n.t('delete.delete')} {I18n.t('group.groups')} &{' '}
              {I18n.t('category.categories')}
            </span>
            <CheckboxControl
              isChecked={userdetail.EditDeleteGroupsCategories}
            />
          </div>
          <div className={css(styles.ellipsis)}>
            <AccordionMenu
              styles={styles.options}
              handleClick={this.handleClick.bind(this)}
              options={options}
            />
          </div>
          <span id={(user && user.data && user.data.id) || 'temp'}> </span>
        </div>

        <Modal
          isOpen={this.state.showEditUserModal}
          onRequestClose={this.handleEditClose}
          contentLabel="Edit User Modal"
          title={I18n.t('models.user.editLabel')}
        >
          <AddUserForm
            isEditType={true}
            onSubmit={this.handleSubmit}
            sitetobeShown={site}
            user={userdetail}
            userPermissions={this.props.userPermissions}
          />
        </Modal>

        <Modal
          isOpen={this.state.showDeleteUserModal}
          onRequestClose={this.handleDeleteClose}
          title={I18n.t('delete.deleteLabel')}
        >
          <Confirm
            confirm={this.handleDeleteUserConfirm.bind(this)}
            deny={this.handleDeleteClose}
            customValue={(site && site.name) || ''}
            deleteText={I18n.t('delete.confirmDeleteUser', {
              customValue: (site && site.name) || ''
            })}
          />
        </Modal>
        <Modal
          isOpen={this.state.showInviteLinkModal && (verificationLink === '' || verificationLink !== null)}
          onRequestClose={this.handleLinkVerificationClose}
          title={I18n.t('viewInvite')}
        >
          <div>

            {verificationLink === '' && (
              <h3 className={css(styles.link)}>Link not found</h3>
            )}
            {verificationLink !== '' && verificationLink !== null && (
              <h3 className={css(styles.link)}>{verificationLink}</h3>
            )}
          </div>
        </Modal>
        <Modal
          isOpen={this.props.resendVerifyCompleted}
          onRequestClose={this.handleResendInviteClose}
          title={'Email Resent'}
        >
          <div className={css(styles.outline)}>
            <div className={css(styles.msg)}><p>{I18n.t('newuser.resendEmailSuccess')}</p></div>
          </div>
        </Modal>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const userPermissions = USER_PERMISSIONS_LIST.map(permission => {
    return {
      label: permission,
      value: permission
    };
  });
  return {
    sites: state.sites,
    userPermissions,
    verificationLink: state.users.verificationLink,
    resendVerifyCompleted: state.auth.resendVerifyCompleted
  };
};
const mapDispatchToProps = dispatch => {
  return {
    deleteSiteUser(id) {
      dispatch(deleteSiteUserAction(id));
    },
    editUser() {
      dispatch(editUserAction(...arguments));
    },
    verifyUserLink() {
      dispatch(viewUserLinkAction(...arguments));
    },
    resendEmail() {
      dispatch(resendVerifyAction(...arguments));
    },
    hideVerificationModal() {
      dispatch(clearInviteLinkAction());
    },
    hideResendInviteModal() {
      dispatch(resendVerifyModalHideAction());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserRow);



// WEBPACK FOOTER //
// ./src/components/data/users/userRow.js